import { cn } from "@/lib/utils";

const sizeVariants = {
  "3xl": "text-3xl font-bold",
  "2xl": "text-2xl font-bold",
  xl: "text-xl font-semibold",
  lg: "text-lg font-semibold",
  base: "text-base font-semibold",
  sm: "text-sm font-semibold",
  xs: "text-xs font-semibold uppercase tracking-wide",
};

const defaultSizeMap: Record<string, keyof typeof sizeVariants> = {
  h1: "2xl",
  h2: "xl",
  h3: "lg",
  h4: "base",
  h5: "sm",
  h6: "xs",
};

const styleVariants = {
  default: "",
  muted: "text-gray-700",
  gradient: "bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent"
};

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: keyof typeof sizeVariants;
  variant?: keyof typeof styleVariants;
}

export const Heading = ({
  as: Tag = "h1",
  size,
  variant = "default",
  className,
  ...props
}: Props) => {
  return (
    <Tag
      className={cn(
        sizeVariants[size ?? defaultSizeMap[Tag]],
        styleVariants[variant],
        className)}
      {...props}
    />
  );
};